import { render, staticRenderFns } from "./page-choose-people.vue?vue&type=template&id=5a8fecb8&"
import script from "./page-choose-people.vue?vue&type=script&lang=js&"
export * from "./page-choose-people.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports